import React, { useState } from "react";
import { Button, Col, Form, Row } from "react-bootstrap";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import {
  useCreateOrderMutation,
  useCreateTableOrderMutation,
} from "../slices/OrdersSlice";
import { useDispatch, useSelector } from "react-redux";
import { setCredentials } from "../slices/authSlice";
import { useCheckFoodItemAvailabilityMutation } from "../slices/FoodItemSilce";
import ReUsableModal from "../components/ReUsableModal";
import { setFoodList } from "../slices/foodListSlice";
import CashfreePayButtonScreen from "./CashfreePayButtonScreen";

const CreateOrderScreen = () => {
  const { userInfo } = useSelector((state) => state.auth);
  const [mobileNumber, setMobileNumber] = useState("");
  // const [otpVerified, setOtpVerified] = useState(false);
  const [notAvailableItems, setNotAvailableItems] = useState({});
  const [itemsForModal, setItemsForModal] = useState();
  const [showModal, setShowModal] = useState(false);
  const dispatch = useDispatch();
  const [seatNumber, setSeatNumber] = useState("");
  const [screen, setScreen] = useState("");
  const [paymentIdCreated, setPaymentIdCreated] = useState(false);

  const navigate = useNavigate();

  const [selectedItems, setSelectedItems] = useState({
    ...userInfo?.selectedItems,
  });

  const [placeOrder, { isLoading: placeOrderLoading }] =
    useCreateOrderMutation();

  const [placeTableOrder, { isLoading: placeTableOrderLoading }] =
    useCreateTableOrderMutation();
  const [checkItemAvailability, { isLoading: itemAvailabilityCheckLoading }] =
    useCheckFoodItemAvailabilityMutation();

  const takeToFoodListScreen = () => {
    setShowModal(false);
    navigate("/foodsList/" + userInfo?.openedOutletGroup);
  };

  const createOrder = async () => {
    try {
      // if (userInfo?.token === null || userInfo?.token === undefined) {
      //   toast.error("Please login to place an order");
      //   return;
      // }
      const itemsAvailable = await checkItemAvailability(
        Object.values(userInfo?.selectedItems).map((item) => ({
          foodItemId: item.itemId,
          itemQuantity: item.selectedQuantity,
          sizeName: item.itemSize,
        }))
      ).unwrap();
      let orderResponse;
      if (Object.keys(itemsAvailable).length === 0) {
        console.log("inside itemsAvailable === 0 ");
        // PAYMENT GATEWAY FUNCTION CALL COMES HERE. Place order will be called if payment was successfull.
        if (userInfo?.tableDetails) {
          orderResponse = await placeTableOrder({
            mobileNumber,
            recentOTP: userInfo?.tableOrderDetails?.tableDetails?.deliveryOtp,
            floor: userInfo?.tableDetails?.floor,
            tableNumber: userInfo?.tableDetails?.tableNumber,
            outletId: Object.values(userInfo?.selectedItems)[0].itemId.slice(
              0,
              11
            ),
            orderDetails: Object.values(userInfo?.selectedItems).map(
              (item) => ({
                foodItemId: item.itemId,
                itemQuantity: item.selectedQuantity,
                sizeName: item.itemSize,
              })
            ),
            deliverTo: userInfo?.deliveryTo?.includes("undefined")
              ? `${screen}, ${seatNumber}`
              : userInfo?.deliveryTo,
            // grossTotal: 525.05,
            grossTotal: (
              Object.values(selectedItems)?.reduce(
                (total, it) =>
                  total +
                  it.selectedQuantity * it.itemOfferPrice +
                  (userInfo?.outletsDetails[0].separateGst
                    ? it.selectedQuantity * it.itemOfferPrice * it.gstPercent
                    : 0) /
                    100,
                0
              ) +
              Object.values(selectedItems)?.reduce(
                (total, it) =>
                  total +
                  it.selectedQuantity * it.itemOfferPrice +
                  (userInfo?.outletsDetails[0].separateGst
                    ? it.selectedQuantity * it.itemOfferPrice * it.gstPercent
                    : 0) /
                    100,
                0
              ) *
                ((userInfo?.selectedOutletId?.companyId?.separatePlaformFee
                  ? userInfo?.selectedOutletId?.companyId?.platformFee
                  : 0) /
                  100)
            ).toFixed(2),
            // grossTotal: grossTotal,
            token: userInfo?.token,
          }).unwrap();
        } else {
          orderResponse = await placeOrder({
            mobileNumber,
            visitorId: userInfo?.visitorId,
            outletId: Object.values(userInfo?.selectedItems)[0].itemId.slice(
              0,
              11
            ),
            orderDetails: Object.values(userInfo?.selectedItems).map(
              (item) => ({
                foodItemId: item.itemId,
                itemQuantity: item.selectedQuantity,
                sizeName: item.itemSize,
              })
            ),
            deliverTo: userInfo?.deliveryTo?.includes("undefined")
              ? `${screen}, ${seatNumber}`
              : userInfo?.deliveryTo,
            // grossTotal: 525.05,
            grossTotal: (
              Object.values(selectedItems).reduce(
                (total, it) =>
                  total +
                  it.selectedQuantity * it.itemOfferPrice +
                  (userInfo?.outletsDetails[0].separateGst
                    ? it.selectedQuantity * it.itemOfferPrice * it.gstPercent
                    : 0) /
                    100,
                0
              ) +
              Object.values(selectedItems).reduce(
                (total, it) =>
                  total +
                  it.selectedQuantity * it.itemOfferPrice +
                  (userInfo?.outletsDetails[0].separateGst
                    ? it.selectedQuantity * it.itemOfferPrice * it.gstPercent
                    : 0) /
                    100,
                0
              ) *
                ((userInfo?.selectedOutletId?.companyId?.separatePlaformFee
                  ? userInfo?.selectedOutletId?.companyId?.platformFee
                  : 0) /
                  100)
            ).toFixed(2),
            // grossTotal: grossTotal,
            token: userInfo?.token,
          }).unwrap();
        }
        if (orderResponse) {
          navigate("/cashfreePayButton", {
            state: {
              orderResponse,
            },
          });
        }
        // if (orderResponse) {
        //   toast.success("Order Placed Successfully");
        //   navigate("/orderConfirmation", {
        //     state: {
        //       orderResponse,
        //     },
        //   });
        //   dispatch(
        //     setCredentials({
        //       ...userInfo,
        //       selectedItems: [],
        //     })
        //   );
        //   dispatch(setFoodList([]));
        // } else {
        //   toast.error("Order Placement failed");
        // }
      } else if (Object.keys(itemsAvailable).length > 0) {
        console.log("inside itemsAvailable > 0 ");
        console.log(itemsAvailable);
        setItemsForModal(
          Object.keys(itemsAvailable).map((it) => {
            return {
              fieldName: it,
              fieldType: "text",
              fieldValue: "only " + itemsAvailable[it] + " available",
              disabled: true,
            };
          })
        );
        // console.log("itemsForModal");
        // console.log(itemsForModal);
        setShowModal(true);
        setNotAvailableItems(itemsAvailable);
      }
    } catch (error) {
      console.error("Error creating order:", error);
      // toast.error("Failed to place order, " + error?.status);
      if (error?.status === 401) {
        toast.error("Session expired, Please login again");
        dispatch(
          setCredentials({
            ...userInfo,
            tableOrderDetails: {},
            token: undefined,
          })
        );
        setMobileNumber("");
        navigate("/login");
      }
    }
  };

  return (
    <div>
      {showModal && (
        <ReUsableModal
          title="Oops..."
          restrictTitle="Food availability has changed. Please select items accordingly"
          payload={itemsForModal}
          show={showModal}
          size="md"
          onHide={takeToFoodListScreen}
          onSubmit={takeToFoodListScreen}
          submit="Okay"
          cancel="Go to Food List"
          submitDisabled={false}
          cancelDisabled={false}
        />
      )}

      <Row className="justify-content-center text-center">
        <Col md={6}>
          <h4 style={{ color: "black" }}>
            {userInfo?.outletsDetails &&
              userInfo?.outletsDetails[0]?.companyId?.companyName}
          </h4>
          <p className="login-subtitle">
            {userInfo?.outletsDetails &&
              userInfo?.outletsDetails[0]?.companyId?.companyCity}
          </p>
          {userInfo?.outletsDetails[0]?.companyId?.companyCategory?.toLowerCase() ===
            "theatre" &&
            !userInfo?.deliveryTo?.toLowerCase().includes("undefined") && (
              <h6 className="login-label">Seat - {userInfo?.deliveryTo}</h6>
            )}
          {!userInfo?.token && (
            <>
              <Form.Control
                type="text"
                style={{ height: "3.5rem", fontSize: "1.3rem" }}
                placeholder="mobile number"
                value={mobileNumber}
                onChange={(e) => {
                  const onlyNums = e.target.value.replace(/\D/g, "");
                  setMobileNumber(onlyNums);
                }}
              />
              <br />
            </>
          )}

          <>
            <br />
            {userInfo?.outletsDetails?.[0]?.companyId?.companyCategory?.toLowerCase() ===
              "theatre" &&
              userInfo?.deliveryTo?.includes("undefined") && (
                <>
                  <Row className="mb-2">
                    <Col>
                      <Form.Label style={{ color: "black" }}>
                        Enter Screen and Seat Number (Optional)
                      </Form.Label>
                    </Col>
                  </Row>
                  <Row className="mb-3 justify-content-center">
                    <Col>
                      <Form.Control
                        style={{ height: "3.5rem", fontSize: "1.3rem" }}
                        type="text"
                        placeholder="Screen"
                        value={screen}
                        onChange={(e) => setScreen(e.target.value)}
                      />
                    </Col>
                    <Col>
                      <Form.Control
                        style={{ height: "3.5rem", fontSize: "1.3rem" }}
                        type="text"
                        placeholder="Seat Number"
                        value={seatNumber}
                        onChange={(e) => setSeatNumber(e.target.value)}
                      />
                    </Col>
                  </Row>
                </>
              )}
            <br />
            <br />
            <h6 style={{ color: "black" }}>
              Total : ₹{" "}
              {(selectedItems !== null || selectedItems !== undefined) &&
                (
                  Object.values(selectedItems)?.reduce(
                    (total, it) => total + it.totalSellingPrice,
                    0
                  ) +
                  Object.values(selectedItems)?.reduce(
                    (total, it) => total + it.totalSellingPrice,
                    0
                  ) *
                    ((userInfo?.selectedOutletId?.companyId?.separatePlaformFee
                      ? userInfo?.selectedOutletId?.companyId?.platformFee
                      : 0) /
                      100)
                ).toFixed(2)}{" "}
            </h6>
            {(userInfo?.token ||
              !userInfo?.outletsDetails[0]?.loginRequired) && (
              <Button onClick={createOrder} className="login-button">
                Pay Now
              </Button>
            )}
          </>
        </Col>
      </Row>
    </div>
  );
};

export default CreateOrderScreen;
